import React from 'react'
import { connect } from 'react-redux'
import { AppState } from 'store/types'
import {
  isInitialized as isInitializedSelector,
  isAuthenticated as isAuthenticatedSelector,
} from 'store/modules/session/selectors'

const mapAuthStateToProps = ({ session }: AppState) => ({
  isInitialized: isInitializedSelector(session),
  isAuthenticated: isAuthenticatedSelector(session),
})

interface OnlyAuthorizedProps {
  isInitialized: boolean
  isAuthenticated: boolean
}

const onlyNotAuthorized = <P extends {}>(
  WrappedComponent: React.ComponentType<P>,
  childOnDenied: React.ReactNode,
  childOnInit: React.ReactNode = null
) => {
  const OnlyNotAuthorized: React.SFC<OnlyAuthorizedProps> = ({
    isInitialized,
    isAuthenticated,
    ...props
  }) => {
    if (!isInitialized) {
      return <>{childOnInit}</>
    }

    if (isAuthenticated) {
      return <>{childOnDenied}</>
    }

    return <WrappedComponent {...props as P} />
  }

  return connect(mapAuthStateToProps)(OnlyNotAuthorized) as unknown as typeof WrappedComponent
}

export default onlyNotAuthorized
